<template>
  <div class="wrap-login" v-if="!hidenHeader">
    <!-- <div class="container-fluid"> -->
    <div class="row">
      <div class="col-xl-4 col-lg-5 col-12 logo-register">
        <router-link to="/" exact>
          <img src="@/assets/images/logo-nxb.png" alt="Hành trang số" style="height:50px;" />
        </router-link>
      </div>
      <div class="col-xl-8 col-lg-7 col-12 login-form text-right mt-2">
        <b-form @submit.prevent="onSubmitLogin">
          <div class="form-wrap display-flex justify-content-end">
            <div class="form-login display-flex mr-lg-2">
              <div class="form-item mr-lg-2">
                <b-form-input v-if="!isLoginkeyCloak" id="input-username" v-model="form.username" type="text" required
                  placeholder="Email đăng nhập" autocomplete="off"
                  class="form-control display-flex-center form-30h form-bg-gray-light border-rd-20" />
                <!-- <b-form-input id="input-username" v-model="form.username" type="text" required placeholder="Email đăng nhập" autocomplete="off" 
                    :class="{ 'is-invalid': submitted && $v.form.username.$error }"
                class="form-control display-flex-center form-30h form-bg-gray-light border-rd-20" />-->
                <span class="error display-block color-err font-size-14 text-left"
                  v-if="!$v.form.username.required && submitted">Vui lòng điền email</span>
                <span class="error display-block color-err font-size-14 text-left" v-if="loginFailed">Tài khoản hoặc mật
                  khẩu không đúng</span>
              </div>
              <div class="form-item text-left ml-lg-2">
                <b-form-input v-if="!isLoginkeyCloak" id="input-password" v-model="form.password" type="password" required
                  placeholder="Mật khẩu" autocomplete="off"
                  class="form-control display-flex-center form-30h form-bg-gray-light border-rd-20" />
                <span class="error display-block color-err font-size-14 text-left"
                  v-if="!$v.form.password.required && submitted">Vui lòng điền mật khẩu</span>
                <router-link v-if="!isLoginkeyCloak" :to="{ name: 'forgot-password' }"
                  class="text-left primary-color font-size-13 forgot-pass-btn desktop-only" exact>Quên mật
                  khẩu?</router-link>
              </div>
              <div class="form-item text-center ml-lg-2 mobile-only m-575">
                <router-link :to="{ name: 'forgot-password' }"
                  class="display-block primary-color font-size-13 forgot-pass-btn mt-2 mb-2" exact
                  v-if="!isLoginkeyCloak">Quên mật khẩu?</router-link>
                <button type="submit" class="btn btn-login font-size-16 form-30h font-sanpro-semibold form-control"
                  :disabled="isLoading" v-if="!isLoginkeyCloak">Đăng nhập</button>

              </div>
              <div class="form-item text-center ml-lg-2 mobile-only">
                <div class="row">
                  <div class="col-12">
                    <h3 class="font-size-16 secondary-color-txt">
                      Bạn chưa có tài khoản?
                      <router-link :to="{ name: 'auth-register' }" exact class="primary-color cursor-pointer">
                        Đăng ký ngay
                      </router-link>
                    </h3>
                  </div>
                  <!-- <div class="col-6">
                    <router-link
                      :to="{name: 'auth-register'}"
                      class="btn btn-register font-size-16 form-30h font-sanpro-semibold form-control"
                      exact
                    >Đăng ký</router-link>
                  </div>
                  <div class="col-6">
                    <button
                      type="button"
                      class="btn student click1 active btn-trial font-size-16 font-sanpro-semibold form-control"
                      @click="loginFast"
                    >Trải nghiệm</button>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="form-action display-md-flex display-lg-flex justify-content-end desktop-only form-md">
              <button type="submit"
                class="btn btn-main btn-login-submit font-size-16 form-30h font-sanpro-semibold border-rd-20 line-height-1 b-login"
                :disabled="isLoading" v-if="!isLoginkeyCloak">Đăng nhập</button>
              <button v-if="isLoginkeyCloak" @click="onLoginSSOKeyCloak" type="button"
                class="btn btn-main btn-login-submit font-size-16 form-30h font-sanpro-semibold border-rd-20 line-height-1 b-login">
                Đăng nhập SSO
              </button>
              <button type="button"
                class="btn student click1 active btn-trial3 font-size-16 font-sanpro-semibold b-logout"
                v-b-modal.modalRegister>
                Đăng ký
              </button>
              <ModalRegister />
              <!-- <button type="button" class="btn student click1 active btn-trial font-size-16 font-sanpro-semibold" @click="loginFast">
                    Trải nghiệm
              </button> -->
            </div>
            <div class="key-header" v-click-outside="hidenFormActive">
              <button v-if="isLoginkeyCloak" @click="onLoginSSOKeyCloak" id="loginSsoMobile" type="button"
                class="btn btn-main btn-login-submit font-size-16 form-30h font-sanpro-semibold border-rd-20 line-height-1 b-login">
                Đăng nhập SSO
              </button>
              &nbsp;&nbsp;
              <a href="javascript:;" class="icon-header-circle text-center border-rd-50"
                :class="{ 'bg-color-hover': isShowActiveCode }" @click="toggleFormActive">
                <i class="icon-key secondary-color-txt"></i>
              </a>
              <b-collapse id="panel_active_book" class="collapse border-rd-8 bg-color-light" :visible="openCollapseActive"
                @show="() => isShowActiveCode = true" @hidden="() => isShowActiveCode = false">
                <ActiveCode :previewBook="true" :isAccExperience="authInfo && authInfo.email === emailPublic"
                  @activeSuccess="() => $root.$emit('bv::toggle::collapse', 'panel_active_book')" />
              </b-collapse>
            </div>
          </div>
        </b-form>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
//import { checkResponse, get, post } from "@/utils/http"
// import { VFBLogin as VFacebookLogin } from "vue-facebook-login-component";
// import GoogleLogin from "vue-google-login";
import moment from "moment";
import JWT from "@/utils/jwt";
import ClickOutside from "vue-click-outside";
// import { Slide } from "vue-burger-menu";
import { EMAIL_PUBLIC, PASS_PUBLIC } from "@/store/auth/constants";
import { APP_CONFIG } from '@/utils/constants'
import { required, email } from "vuelidate/lib/validators";
import HttpService from "@/utils/httpData"
import router from "@/router"
export default {
  name: "HeaderGuest",
  components: {
    ModalRegister: () => import("@/views/auth/ModalRegister.vue"),
    ActiveCode: () => import("@/modules/ebooks/_components/common/ActiveCode.vue")
    // VFacebookLogin,
    // GoogleLogin,
    // Slide,
  },
  directives: {
    ClickOutside
  },
  data() {
    return {
      authInfo: {},
      emailPublic: EMAIL_PUBLIC,
      configKeyclock: {},
      isLoginkeyCloak: true,
      hidenHeader: false,
      submitted: false,
      status: false,
      isShowActiveCode: false,
      openCollapseActive: false,
      loginFailed: false,
      menus: {
        buttonText: "Slide",
      },
      currentMenu: "slide",

      isAuthorize: JWT.getAccessToken(),
      params: {
        nextUrl: this.$route.params.nextUrl,
      },
      navigations: [
        {
          label: "Trang chủ",
          route: {
            name: "home",
          },
        },
        {
          label: "Giới thiệu",
          route: {
            name: "page-about",
          },
        },
        {
          label: "Hỗ trợ",
          route: {
            name: "page-support",
          },
        },
      ],
      optionDays: Array.apply(0, Array(31)).map((element, index) => index + 1),
      optionMonths: Array.apply(0, Array(12)).map(
        (element, index) => index + 1
      ),
      optionYears: Array.apply(0, Array(35)).map(
        (element, index) => index + 1979
      ),
      isRequest: false,
      isLogin: false,
      isRegister: false,
      form: {
        type: "student",
        date_of_birth: {
          day: 1,
          month: 1,
          year: 1991,
        },
        username: "",
        password: "",
        first_name: "",
        last_name: "",
      },
      show: true,
      facebookInstance: null,
      facebookLoginOptions: {
        scope: "email,user_gender,user_birthday",
      },
      googleLoginParams: {
        client_id:
          "647028456277-fjiue4tr0q1h5vjtp79l5g42g9ivp9si.apps.googleusercontent.com",
      },
      googleLoginRenderParams: {
        width: "auto",
        height: 36,
        longtitle: true,
      },
    };
  },
  validations() {
    return {
      form: {
        username: {
          required,
          email,
        },
        password: {
          required,
        },
      },
    };
  },
  computed: {
    // ...mapState("auth", ["isLoggedIn", "isLoading", "errors", "user"]),
    ...mapState("auth", ["isLoading", "errors", "user"]),
  },
  watch: {
    $route: "checkDisplayHeader",
  },
  async mounted() {
    const request = await fetch(APP_CONFIG.dataUrl + "IsLoginkeyCloak");
    const response = await request.json();
    this.configKeyclock = response
    if (this.configKeyclock.isLoginKeyClock == 0) {
      this.isLoginkeyCloak = false;
    }
    else {
      this.isLoginkeyCloak = true;
    }
  },
  created() {
    this.loginFast()
    this.checkDisplayHeader();

  },
  methods: {
    ...mapActions(`auth`, [
      "authLogin",
      "authRegister",
      "authLoginFacebook",
      "authLoginGoogle",
      "authLogout"
    ]),
    hidenFormActive() {
      this.openCollapseActive = false;
    },
    loginFast(routerTo = 'NOTREDIRECT') {
      var postData = {
        username: EMAIL_PUBLIC,
        password: PASS_PUBLIC,
        router_to: routerTo,
        callbackFunction: () => {
          this.authInfo = JWT.getAuth()
        }
      }
      this.authLogin(postData);

    },
    checkDisplayHeader() {
      this.hidenHeader = this.$route.meta.hideHeader ? true : false
    },
    ...mapActions("common", [
      "setIdActiveBookInHeader",
      "acToggleModalActiveBook",
      "actionCountNotificationNotRead",
      "setDataDetailNotifi",
      "actionCheckSlideActiveBook",
      "actionCheckArraySlide",
      "acToggleModalShowNotify",
      "actionSetDataModalNoti"
    ]),
    changeUserType(type) {
      this.form.type = type;
    },
    toggleFormActive() {
      if (this.authInfo.email === EMAIL_PUBLIC) {
        this.openCollapseActive = !this.openCollapseActive;
      } else {
        this.acToggleModalActiveBook(true);
        // console.log('haha vao');
        // this.actionCheckSlideActiveBook({isShowSlide: true})
        // this.arraySlide = [
        //     {id: 1, src: require('@/assets/img/HDKH1.png')},
        //     {id: 2, src: require('@/assets/img/HDKH2.png')},
        //     {id: 3, src: require('@/assets/img/HDKH3.png')}
        // ]
        // this.actionCheckArraySlide(this.arraySlide)
      }
      // this.$root.$emit('bv::toggle::collapse', 'panel_active_book');
    },

    updateOptionDays() {
      const daysInMonth = moment(
        `${this.form.date_of_birth.year}-${this.form.date_of_birth.month}`,
        "YYYY-MM"
      ).daysInMonth();
      this.optionDays = Array.apply(0, Array(daysInMonth)).map(
        (element, index) => index + 1
      );
      if (this.form.date_of_birth.day > daysInMonth) {
        this.form.date_of_birth.day = 1;
      }
    },
    toggleLogin() {
      this.isLogin = true;
      this.isRegister = false;
    },
    toggleRegister() {
      this.isRegister = true;
      this.isLogin = false;
    },
    checkLogIn() {
      if (!this.isAuthorize) {
        this.loginFailed = true;
      }
    },
    onSubmitLogin(evt) {
      evt.preventDefault();
      this.loginFailed = false;
      this.submitted = true;
      // console.log('Login: ', this.$v);

      // stop here if form is invalid
      // this.$v.$touch();
      // if (this.$v.$invalid) {
      //   return;
      // }

      let loginToken = this.authLogin({
        username: this.form.username,
        password: this.form.password,
      });

      setTimeout(this.checkLogIn, 1000);
    },
    onLoginSSOKeyCloak() {
      const pageUrl = window.location.href.replace('&', 'th98th');
      window.location.href = this.configKeyclock.urlServerKeyCloak + "/realms/" + this.configKeyclock.realm + "/protocol/openid-connect/auth?response_type=code&client_id=" + this.configKeyclock.audience + "&redirect_uri=" + window.location.origin + this.configKeyclock.redirect + '?urlReturn=' + pageUrl
    },
    onSubmitRegister(evt) {
      evt.preventDefault();

      let dob = moment(
        `${this.form.date_of_birth.year}-${this.form.date_of_birth.month}-${this.form.date_of_birth.day}`,
        "YYYY-MM-DD"
      ).format("YYYY-MM-DD");

      this.authRegister({
        type: this.form.type,
        username: this.form.username,
        name: this.form.username,
        email: this.form.username,
        password: this.form.password,
        password_confirmation: this.form.password,
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        date_of_birth: dob,
      });
    },

    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    // facebookInit(obj) {
    //   this.facebookInstance = obj.FB;
    // },
    // facebookLogin(response) {
    //   if (response.status == "connected") {
    //     this.authLoginFacebook({
    //       user_id: response.authResponse.userID,
    //       access_token: response.authResponse.accessToken,
    //     });
    //   }

    //   // Terminate current facebook logged in
    //   // this.facebookInstance.logout()
    // },
    // googleLoginSuccess(googleUser) {
    //   // For access_token
    //   const token = googleUser.getAuthResponse();

    //   // Request to auth user
    //   this.authLoginGoogle(token.id_token);

    //   // Terminate current google logged in
    //   googleUser.disconnect();
    // },
    logout() {
      this.authLogout();
      this.isAuthorize = false;
      router.push("/");
    },
  },
};
</script>

<style lang="scss" scope>
.btn-trial3 {
  // background: #E1EFFF;
  border-radius: 20px;
  color: #0F3DBA;
  font-weight: bold;
  letter-spacing: 1px;
  margin-left: 20px;
  padding: 0px 20px;

  &:hover {
    color: #0F3DBA;
  }
}

.menu-mb {
  .box {
    .try__use {
      .btn_try {
        position: relative;

        button {
          background: rgb(221, 236, 254);
          border: none;
          border-radius: 24px;
          color: rgb(22, 63, 179);
          line-height: 24px;
          padding: 2px 20px;
          margin-top: 18px;
        }
      }
    }
  }
}

.bm-burger-button {
  cursor: pointer;
  height: 30px;
  left: 25px;
  position: absolute;
  top: 3px;
  width: 36px;
}

.bm-overlay {
  background: none;
}

.nav-separator {
  display: inline-block;
  border-left: 1px solid #8597a5;
  height: 32px;
  margin: 10px 12px 0;
}

.nav-auth {
  margin: 10px 6px 10px 6px;

  .nav-link {
    background: #ddecfe;
    border: none;
    border-radius: 24px;
    color: #163fb3;
    line-height: 24px;
    padding: 2px 20px;

    &:hover,
    &.active {
      background: #163fb3;
      color: #fff;

      &:before {
        border: none;
      }
    }
  }
}

.btn {
  height: 32px;
  /*line-height: 32px;*/
  font-size: 13px;
  font-weight: 500;
}

.auth__input {
  background: #e9ecef;
  border: none;
  border-radius: 1.5rem;
  margin-bottom: 1.5rem;

  &--right {
    text-align-last: right;
  }
}

.auth__btn {
  background: #163fb3;
  border: none;
  border-radius: 1.5rem;
  margin-bottom: 1.5rem;
}

.auth__separator {
  position: relative;
  border-bottom: 1px solid #e9ecef;
  padding: 0.5rem 0;
  margin-bottom: 1.5rem;

  span {
    position: absolute;
    top: 0.3rem;
    left: calc(50% - 2.5rem);
    display: inline-block;
    width: 5rem;
    background: #fff;
    color: #879aa9;
  }
}

.auth__form {
  padding: 3rem;
  background: #fff;
}

.btn-login-submit {
  letter-spacing: 0.04em;
  padding: 0.5rem 1rem;
}

.key-header {
  margin-top: 5px;
  position: relative;
}

#panel_active_book {
  position: absolute;
  left: -350px;
  top: 51px;
  z-index: 99;
  text-align: left;
}

@media (max-width: 1024px) {
  .menu-mb {
    .box {
      .inner-img {
        img {
          height: 40px;
        }
      }

      .btn-try {
        position: relative;

        .try__use {
          button {
            position: absolute;
            left: -10px;
            width: 100px;
            background: rgb(221, 236, 254);
            border: none;
            border-radius: 24px;
            color: rgb(22, 63, 179);
            line-height: 24px;
            padding: 2px 20px;
            margin-top: 18px;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .menu-mb .box .try__use .btn_try button {
    background: #ddecfe;
    border: none;
    border-radius: 24px;
    color: #163fb3;
    line-height: 24px;
    padding: 2px 20px;
    margin-top: 18px;
    position: absolute;
    left: -10px;
    width: 97px;
  }

  .menu-mb .box .inner-img img {
    height: 30px;
  }
}

@media (max-width: 425px) {
  .menu-mb .box .try__use .btn_try button {
    background: #ddecfe;
    border: none;
    border-radius: 24px;
    color: #163fb3;
    line-height: 24px;
    padding: 0px !important;
    margin-top: 18px;
    position: absolute;
    left: -20px;
    width: 70px;
    font-size: 12px;
  }

  .menu-mb .box .inner-img img {
    height: 30px;
  }

  p.private-footer-new-p {
    font-size: 13px;
    color: #879aa9;
  }
}

@media (max-width: 425px) {
  .menu-mb .box .try__use .btn_try button {
    left: -30px;
  }
}

@media (max-width: 320px) {
  .menu-mb .box .try__use .btn_try button {
    padding: 0px !important;
    margin-top: 18px;
    position: absolute;
    left: 241px;
    width: 60px;
    font-size: 11px;
  }

  .menu-mb .box .inner-img img {
    height: 27px;
  }
}
</style>

<style lang="scss">
.modal-body {
  background: #e9ecef;
  padding: 0;
}

.modal-header {
  position: relative;
  border-bottom: none;
  padding: 0;

  .close {
    position: absolute;
    left: 0;
    top: 1rem;
    padding: 0.5rem;
    color: #000;
    z-index: 9999;
  }
}

// .modal-footer {
//   display: none;
// }

.v-facebook-login {
  min-width: 100% !important;
  max-width: 100% !important;
  height: 36px;
  line-height: 0.5rem;
}

// .tabs {
//   .nav-tabs {
//     border-bottom: none;
//   }

//   .nav-item {

//     .nav-link {
//       border: none;
//       border-bottom: 3px solid transparent;
//       color: #8597a5;
//       font-size: 13px;
//       padding:5px;

//       &.active {
//         color: #163fb3 !important;
//         border-bottom: 3px solid #163fb3;
//         background-color: #F3F6FB;
//       }
//     }
//   }
// }
@media screen and (max-width: 1024px) {
  .form-md {
    display: flex;

    .b-login,
    .b-logout {
      width: 120px;
      font-size: 14px;
    }
  }
}

#loginSsoMobile {
  display: none;
}

@media screen and (max-width: 991px) {
  .form-md {
    display: none;
  }

  #loginSsoMobile {
    display: inline-block;
  }
}

@media screen and (max-width: 575px) {
  .m-575 {
    display: flex;
    justify-content: space-between;

    .btn-login {
      width: auto;
    }
  }
}
</style>

